import React, { FC, memo, useMemo } from 'react';
import { MultipleSelectedDropdown } from 'src/components/dropdown/MultipleSelectedDropdown';
import { ListingStatusEnum } from 'src/enums';
import { usePermissions } from 'src/hooks';
import { GenericMenuOptionV2 } from 'src/types';

interface Props {
  handleOptionChange: (
    options: GenericMenuOptionV2 | GenericMenuOptionV2[]
  ) => void;
}

const Component: FC<Props> = ({ handleOptionChange }) => {
  const { viewTransferListingStock: canViewTransfer } = usePermissions();

  const allStatus = useMemo(() => {
    const statusArr = [
      { id: 1, name: 'AVAILABLE', value: ListingStatusEnum.Available },
      { id: 2, name: 'DEFECTIVE', value: ListingStatusEnum.Defective },
      { id: 3, name: 'PURCHASED', value: ListingStatusEnum.Purchased },
      //   { id: 4, name: 'FOR WARRANTY', value: ListingStatusEnum.ForWarranty }, //for checking why this not included
      { id: 5, name: 'ON HOLD', value: ListingStatusEnum.OnHold },
      { id: 13, name: 'LOSS', value: ListingStatusEnum.Loss },
      { id: 14, name: 'BUNDLED', value: ListingStatusEnum.Bundled },

      { id: 6, name: 'RMA ONGOING', value: ListingStatusEnum.RmaOngoing },
      {
        id: 7,
        name: 'RMA REPLACE SAME ITEM',
        value: ListingStatusEnum.RmaReplaceSameItem
      },
      {
        id: 8,
        name: 'RMA REPLACE NEW ITEM',
        value: ListingStatusEnum.RmaReplaceNewItem
      },
      { id: 9, name: 'RMA REPAIRED', value: ListingStatusEnum.RmaRepaired },
      {
        id: 10,
        name: 'RMA REFUND WITH NEW ITEM',
        value: ListingStatusEnum.RmaRefundWithNewItem
      },
      { id: 11, name: 'VOID WARRANTY', value: ListingStatusEnum.VoidWarranty }
    ];
    canViewTransfer &&
      statusArr.push({
        id: 12,
        name: 'TRANSFER',
        value: ListingStatusEnum.Transfer
      });
    return statusArr;
  }, [canViewTransfer]);

  return (
    <>
      <MultipleSelectedDropdown
        label="Status"
        defaultAll={true}
        options={allStatus}
        onHandleChange={(value: GenericMenuOptionV2 | GenericMenuOptionV2[]) =>
          handleOptionChange(value)
        }
        isMultiple={true}
      />
    </>
  );
};

export const StatusDropdown = memo(Component);
